import { Box, Button, Modal, Paper, Typography } from '@mui/material'
import React from 'react'
import { NivosFile } from 'types/nivos-file'
import { get } from 'utils/common'

interface OwnProps {
  file: NivosFile | undefined
  setFile: (_: NivosFile | undefined) => void
}

const DownloadPrompt: React.FC<OwnProps> = props => {
  const [downLoading, setDownLoading] = React.useState(false)
  const { file, setFile } = props

  return (
    <Modal open={file !== undefined}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        height={1}
      >
        <Paper
          variant={'elevation'}
          sx={{
            width: 'min-content',
            maxHeight: '95vh',
            overflow: 'auto',
            padding: 2
          }}
          elevation={8}
        >
          <Typography gutterBottom>Continue to download file?</Typography>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'space-evenly'}
            width={300}
          >
            <Button
              variant={'contained'}
              disabled={downLoading}
              onClick={() => {
                if (file !== undefined) {
                  setDownLoading(true)
                  void get(`/document/file/${file.id}/download/`, false, true)
                    .then(response => response.blob())
                    .then((blob: Blob) => {
                      const url = window.URL.createObjectURL(new Blob([blob]))
                      const link = document.createElement('a')
                      link.href = url
                      link.setAttribute(
                        'download',
                        `${file.name.trim()}.${file.fileType.toLowerCase()}`
                      )
                      document.getElementById('root')?.appendChild(link)
                      link.click()
                      link.parentNode?.removeChild(link)
                      setDownLoading(false)
                      setFile(undefined)
                    })
                }
              }}
            >
              {downLoading ? 'Loading...' : 'Download'}
            </Button>
            <Button
              disabled={downLoading}
              variant={'outlined'}
              onClick={() => setFile(undefined)}
            >
              Cancel
            </Button>
          </Box>
        </Paper>
      </Box>
    </Modal>
  )
}

export default DownloadPrompt
